import Axios from 'axios'
import router from '../router'
// import ElementUI from 'element-ui'
import md5 from 'js-md5'

Axios.defaults.timeout = 300000;// 响应时间
// Axios.defaults.baseURL = process.env.HOST;

Axios.interceptors.request.use(config => {

    config.baseURL = process.env.HOST

    let Appkey = '1874100931';
    let AppSecret = 'ecaa5b968a76fbf15bc67fc50335fc61';

    let timeTamp = parseInt(new Date().getTime() / 1000);
    let LcSign = md5(Appkey + timeTamp + AppSecret);
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    config.headers['LC-Appkey'] = Appkey;
    config.headers['LC-Sign'] = LcSign;
    config.headers['LC-Timestamp'] = timeTamp;
    
    // if (userInfo && userInfo.session_id) {
    //     config.headers['LC-Session'] = userInfo.session_id;
    //     // config.headers['LC-Session'] = '0b951e779eb246b926b0f50fb64e714485275';
    // } else {
    //     config.headers['LC-Session'] = '6dc8051f641dc911d3480fab7f37463b' + localStorage.getItem('uId');
    // }
    config.headers['LC-Session'] = '5538227e3d4a55b309ae4d50e8aee17e1';

    return config;
}, error => {
    return Promise.reject(error);
});

Axios.interceptors.response.use(response => {
    return response;
}, error => {
    return Promise.reject(error);
});

/**
 * 公共请求入口
 * @param param 'object'
 * @param url   'string'
 * @param type  'get || post'
 * @returns {Promise}
 */
export const commonPromise = (param = {}, url, type, contentType) => {
    // console.log(url)
    // console.log('请求参数', param)
    // console.log(param instanceof Object)
    console.log('contentType', contentType)
    let contentTypes = contentType === 'formData' ? {'Content-Type': 'multipart/form-data'} : {}
    let paramType = true
    if (param instanceof Object) {
      paramType = true
    } else if (typeof param == 'string') {
      try {
        let obj = JSON.parse(param);
        if(typeof obj == 'object' && obj ){
          paramType = true
        }else{
          paramType = false
        }
      } catch(e) {
          console.log('error：' + param + '!!!' + e);
          paramType = false
      }
    } else {
      paramType = false
    }
    return new Promise((resolve, reject) => {
        let request = type === 'post' ? Axios({url: paramType ? url : url + '/' + param, method: 'post', data: paramType ? param : {}, headers: contentTypes}) : Axios({url: paramType ? url : url + '/' + param, method: 'get', params: paramType ? param : {}})
        request.then(res => {
            if (res.data.code === 0) {
                resolve(res.data);
            } else if (res.data.code === 1) {
                resolve(res.data);
            } else if (res.data.code === 2) {
                resolve(res.data);
            } else if (res.data.code === 3) {
                resolve(res.data);
            } else if (res.data.code === 4) {
                resolve(res.data);
            } else if (res.data.code === 101) {
                resolve(res.data);
            } else if (res.data.code === 8010) {
                resolve(res.data);
            } else if (res.data.code === 8009) {
                resolve(res.data);
            } else if (res.data.code === 8008) {
                resolve(res.data);
            } else if (res.data.code === 8007) {
                resolve(res.data);
            } else if (res.data.code === 1006) {
                resolve(res.data);
            } else if (res.data.code === 1007) {
                resolve(res.data);
            } else if (res.data.code === 1004) {
                localStorage.removeItem('userInfo');
                // ElementUI.Message.error(res.data.msg);
                reject(res.data.msg);
            } else {
                // ElementUI.Message.error(res.data.msg);
                reject(res.data.msg);
            }
        }).catch(err => {
            // reject(err.data.msg);
        });
    })
}



// WEBPACK FOOTER //
// ./src/http/index.js